import React from 'react';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'components/Dropdown';
import StarredFolderIcon from 'icons/StarredFolderIcon';

type StarredLoadToggleProps = React.PropsWithChildren<{
  tab: string;
  starredLoads: string[];
  addLoadTab: (proNumber: string) => void;
}>;

export default function StarredLoadList({
  tab,
  starredLoads,
  addLoadTab,
}: StarredLoadToggleProps) {
  return starredLoads.length ? (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type='button' className='outline-none'>
          <StarredFolderIcon className='min-h-5 h-5 min-w-5 w-5 cursor-pointer' />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {starredLoads.map((slID) => (
          <DropdownMenuItem
            key={slID}
            disabled={slID === tab}
            onSelect={() => addLoadTab(slID)}
          >
            Load - {slID}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  ) : null;
}
